module.exports = __webpack_public_path__ + "static/media/thumbnail.f05de5e2.jpg";